module.exports = __webpack_public_path__ + "static/18-178f22a68e316335952ff8e78c71a8fc.jpeg";